import { render } from "./ViewLogin.vue?vue&type=template&id=06953744&scoped=true"
import script from "./ViewLogin.vue?vue&type=script&lang=ts"
export * from "./ViewLogin.vue?vue&type=script&lang=ts"

import "./ViewLogin.vue?vue&type=style&index=0&id=06953744&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-06953744"

export default script